import React from 'react';

/*
  type addPropsIfValidChild = (props: object) => (child: React.ReactNode | any) => React.ReactNode | any;

  ---

  An HOC helper, containing a validity guard, to inject props into a React child.

  ---

  Example usage within an iterator:
    React.Children.map(children, addPropsIfValidChild({ ...propsToInject }))
*/

const addPropsIfValidChild = props => child =>
  React.isValidElement(child) ? React.cloneElement(child, props) : child;

export default addPropsIfValidChild;
